<template>
  <div class="maincontainer header">
    <a class="logo" @click="toLogin" style="cursor:pointer;"></a>
    <a style="cursor:pointer;" @click="changeLang(targetLanguage)">{{ targetLanguage.displayName }}</a>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'commonHeader',
  computed: {
    ...mapGetters([
      'targetLanguage'
    ])
  },
  props: {
    enableToLogin: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    changeLang (targetLanguage) {
      this.$store.dispatch('changeLanguage', targetLanguage.code)
      this.$i18n.locale = targetLanguage.code
      this.$emit('changeLanguage')
    },
    toLogin () {
      this.enableToLogin && this.$router.push('/')
    }
  }
}
</script>

<style scoped>

</style>
